import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseSharedModule } from '@fuse/shared.module';
import { SharedServicePositionComponent } from './shared-service-position.component';
import { ProcessStatusModule } from '../process-status/process-status.module';

@NgModule({
  imports: [
    CommonModule,
   FuseSharedModule,
   ProcessStatusModule
  ],
  declarations: [
    SharedServicePositionComponent
  ],
  providers: [
  ],
  exports: [
    SharedServicePositionComponent
  ],
  entryComponents: [
  ]
})
export class SharedServicePositionModule { }
